import { Box, styled } from '@mui/material'

export const TestimonialContainer = styled('div')(({ theme }) => ({
  color: theme.palette.surface[100],
  display: 'flex',
  alignItems: 'center',
  minHeight: 400,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}))

export const PersonalInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  marginRight: 0,
  [theme.breakpoints.up('sm')]: {
    marginRight: theme.spacing(4),
  },
}))

export const ContentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}))

export const TestimonialHead = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: 'block',
  flexDirection: 'column',
  alignItems: 'start',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
  },
}))

export const ButtonsContainerDesktop = styled(Box)(({ theme }) => ({
  display: 'none',
  alignSelf: 'center',
  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
}))

export const ButtonsContainerTablet = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.25),
  marginTop: theme.spacing(2),
}))

export const ButtonsContainerMobile = styled(Box)(() => ({
  display: 'flex',
}))

export const TestimonialWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}))
